<template>
    <div class="d-flex align-items-center w-100 rounded bg-white mpshadow-sm py-1 px-4 mb-2" @click="click($event)">
        <div class="icon mr-3">
            <slot name="icon"></slot>
        </div>
        <h6 class="font-md my-2 mr-auto"><slot name="title"></slot></h6>
        <img src="images/icon-chevron-right.svg">
    </div>
</template>

<script>
    export default {
        methods: {
            click(e) {
                this.$emit('click', e)
            }
        },
    }
</script>

<style scoped>
    .icon {
        -webkit-box-flex: 0;
        flex: 0 0 calc(100% / 12);
        max-width: calc(100% / 12);
        width: 1.5rem;
        height: 1.5rem;
    }
    .icon img {
        max-width: 100%;
        max-height: 100%;
        height: auto;
    }
</style>